import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { FieldValues } from "react-hook-form";
import { Loader } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useNotification } from "~/Hooks/useNotification";
import { magpCMSApi, post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { useDocumentDetails } from "../../../ApprovalManagement/Drilldown.Hooks";
import { useContractAdministration } from "../Manual.hook";
import { fields } from "../manualConstants";
import { ContractAdministrationProcessFlowChart } from "./ContractAdministrationProcessFlowChart";

export const ContractAdministration: React.FC = (): JSX.Element => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();

  const [tabsData, setTabsData] = useState<any[]>([]);
  const [subTabsData, setSubTabsData] = useState<any[]>([]);

  const [listId, setListId] = useState("");
  const [toggleId, setToggleId] = useState("");
  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");

  const {
    data: contractAdministrationData,
    isLoading: isLoadingContractAdministration,
    refetch: refetchData,
  } = useContractAdministration(listId || "40", toggleId || "139");
  const {
    data: contractAdministrationDataById,
    isLoading: isLoadingContractAdministrationById,
    refetch: refetchDataById,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (approveId) {
      return;
    }

    const thirdChildActiveTab = query.get("thirdChildActiveTab");

    if (
      query.get("activeTab") === "contractAdministration" &&
      query.get("subActiveTab") === "contractManagementImplementation"
    ) {
      navigate(
        `/dedicated/magp/manual?activeTab=contractAdministration&subActiveTab=contractManagementImplementation&thirdChildActiveTab=${
          thirdChildActiveTab ?? "contractManagementImplementationOverview"
        }`,
        {
          replace: true,
        }
      );
      if (thirdChildActiveTab === "contractManagementImplementationOverview") {
        setListId("40");
        setToggleId("139");
      } else if (thirdChildActiveTab === "contractManagementImplementationPolicies") {
        setListId("40");
        setToggleId("140");
      } else if (thirdChildActiveTab === "contractManagementImplementationProcessFlowChart") {
        setListId("40");
        setToggleId("141");
      } else {
        setListId("40");
        setToggleId("139");
      }
      // refetchData();
    }
    if (query.get("activeTab") === "contractAdministration" && query.get("subActiveTab") === "contractRenewal") {
      navigate(
        `/dedicated/magp/manual?activeTab=contractAdministration&subActiveTab=contractRenewal&thirdChildActiveTab=${
          thirdChildActiveTab ?? "contractRenewalOverview"
        }`,
        {
          replace: true,
        }
      );
      if (thirdChildActiveTab === "contractRenewalOverview") {
        setListId("41");
        setToggleId("168");
      } else if (thirdChildActiveTab === "contractRenewalPolicies") {
        setListId("41");
        setToggleId("169");
      } else if (thirdChildActiveTab === "contractRenewalProcessFlowChart") {
        setListId("41");
        setToggleId("170");
      } else {
        setListId("41");
        setToggleId("168");
      }
      // refetchData();
    }
    if (query.get("activeTab") === "contractAdministration" && query.get("subActiveTab") === "contractTermination") {
      navigate(
        `/dedicated/magp/manual?activeTab=contractAdministration&subActiveTab=contractTermination&thirdChildActiveTab=${
          thirdChildActiveTab ?? "contractTerminationOverview"
        }`,
        {
          replace: true,
        }
      );
      if (thirdChildActiveTab === "contractTerminationOverview") {
        setListId("42");
        setToggleId("171");
      } else if (thirdChildActiveTab === "contractTerminationPolicies") {
        setListId("42");
        setToggleId("172");
      } else if (thirdChildActiveTab === "contractTerminationProcessFlowChart") {
        setListId("42");
        setToggleId("173");
      } else {
        setListId("42");
        setToggleId("171");
      }
      // refetchData();
    }
    if (query.get("activeTab") === "contractAdministration" && query.get("subActiveTab") === "contractCloseout") {
      navigate(
        `/dedicated/magp/manual?activeTab=contractAdministration&subActiveTab=contractCloseout&thirdChildActiveTab=${
          thirdChildActiveTab ?? "contractCloseoutOverview"
        }`,
        {
          replace: true,
        }
      );
      if (thirdChildActiveTab === "contractCloseoutOverview") {
        setListId("43");
        setToggleId("174");
      } else if (thirdChildActiveTab === "contractCloseoutPolicies") {
        setListId("43");
        setToggleId("175");
      } else if (thirdChildActiveTab === "contractCloseoutProcessFlowChart") {
        setListId("43");
        setToggleId("176");
      } else {
        setListId("43");
        setToggleId("174");
      }
      // refetchData();
    }
  }, [query.get("activeTab"), query.get("subActiveTab")]);

  useEffect(() => {
    refetchData();
  }, []);
  useEffect(() => {
    if (listId && toggleId) {
      refetchData();
    }
  }, [listId, toggleId]);
  useEffect(() => {
    if (query?.get("id")) {
      refetchDataById();
    }
  }, [query?.get("id")]);
  const contractAdministrationFormConfig: FormConfig = {
    initialValues: {
      title: contractAdministrationDataById?.payload
        ? decodeHTML(contractAdministrationDataById?.payload?.title)
        : decodeHTML(contractAdministrationData?.[0]?.title),
      field_contract_admin_desc_en: contractAdministrationDataById?.payload
        ? decodeHTML(contractAdministrationDataById?.payload?.field_contract_admin_desc_en?.value)
        : decodeHTML(contractAdministrationData?.[0]?.field_contract_admin_desc_en),
      field_contract_admin_desc_ms: contractAdministrationDataById?.payload
        ? decodeHTML(contractAdministrationDataById?.payload?.field_contract_admin_desc_ms?.value)
        : decodeHTML(contractAdministrationData?.[0]?.field_contract_admin_desc_ms),
      field_contract_admin_desc_zh: contractAdministrationDataById?.payload
        ? decodeHTML(contractAdministrationDataById?.payload?.field_contract_admin_desc_zh?.value)
        : decodeHTML(contractAdministrationData?.[0]?.field_contract_admin_desc_zh),
      field_contract_video_url: contractAdministrationDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "video_url.mp4",
              status: "done",
              url: contractAdministrationDataById?.payload?.field_contract_video_url,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "video_url.mp4",
              status: "done",
              url: contractAdministrationData?.[0]?.field_contract_video_url,
            },
          ]),
      field_contract_details_web_image: contractAdministrationDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_contract_details_web_image.png",
              status: "done",
              url: contractAdministrationDataById?.payload?.field_contract_details_web_image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_contract_details_web_image.png",
              status: "done",
              url: contractAdministrationData?.[0]?.field_contract_details_web_image,
            },
          ]),
      field_contract_web_flowchart_img: contractAdministrationDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_contract_web_flowchart_img.png",
              status: "done",
              url: contractAdministrationDataById?.payload?.field_contract_web_flowchart_img,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_contract_web_flowchart_img.png",
              status: "done",
              url: contractAdministrationData?.[0]?.field_contract_web_flowchart_img,
            },
          ]),
    },
    fields: fields.contractAdministration,
  };

  useEffect(() => {
    const fetchTabsData = async () => {
      try {
        const response = await magpCMSApi.get(`/api/contract-administration-list/all-fields`);
        const tabData = response.data.map((tab: any) => {
          const listId = tab?.id;
          const label = tab?.field_contract_process_name_en.replace(/^\d+\.\d+\s*/, "");
          let key = label.replace(/\s+/g, "").replace(/\s[a-z]/g, (match: any) => match.trim().toUpperCase());
          key = key.charAt(0).toLowerCase() + key.slice(1);
          return { listId, label, key };
        });
        setTabsData(tabData);
      } catch (error) {}
    };

    fetchTabsData();

    const subActiveTab = query.get("subActiveTab") ?? "contractManagementImplementation";
    const listId =
      subActiveTab === "contractManagementImplementation"
        ? "40"
        : subActiveTab === "contractRenewal"
          ? "41"
          : subActiveTab === "contractTermination"
            ? "42"
            : "43";

    fetchSubTabsData(subActiveTab, listId);
  }, []);

  useEffect(() => {
    if (contractAdministrationDataById !== undefined && !isLoadingContractAdministration) {
      const urlParams = new URLSearchParams(window.location.search);
      const subActiveTab = urlParams.get("subActiveTab") || "contractManagementImplementation";
      const selectedTab = tabsData.find((tab) => tab.key === subActiveTab);

      if (selectedTab !== undefined) {
        fetchSubTabsData(subActiveTab, selectedTab.listId);
      }
    }
  }, [contractAdministrationDataById, tabsData, isLoadingContractAdministration]);

  const fetchSubTabsData = async (activeKey: string, listId: string) => {
    if (!listId) {
      return;
    }
    try {
      const response = await magpCMSApi.get(`/api/contract-administration-topbar-toggle/all-fields?listId=${listId}`);
      const subTabData = response.data.map((subTab: any) => {
        const formattedName = subTab.name
          .replace(/\s+/g, "")
          .replace(/(\s[a-z])/g, (match: string) => match.trim().toUpperCase())
          .replace(/[^a-zA-Z0-9]/g, "");
        return {
          toggleId: subTab.id,
          listId: subTab.field_contract_admin_reference,
          label: subTab.name,
          key: `${activeKey}${formattedName}`,
        };
      });

      setSubTabsData(subTabData);
    } catch (error) {}
  };

  const handleTabChange = (activeKey: string) => {
    const selectedTab = tabsData.find((tab) => tab.key === activeKey);
    if (selectedTab) {
      fetchSubTabsData(activeKey, selectedTab.listId);
      navigate(`${window.location.pathname}?activeTab=contractAdministration&subActiveTab=${activeKey}`);
    }
  };

  const handleSubTabChange = (listId: string, activeKey: string) => {
    setListId(listId);
    const subTab = subTabsData.find((subTab) => subTab.key === activeKey);
    if (subTab) {
      setToggleId(subTab.toggleId);
    }
    navigate(
      `${window.location.pathname}?activeTab=contractAdministration&subActiveTab=${query?.get(
        "subActiveTab"
      )}&thirdChildActiveTab=${activeKey}`
    );
  };
  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
      "field_contract_details_web_image",
      "field_contract_web_flowchart_img",
      "field_contract_video_url",
    ];

    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field && field[0]) {
          if (field[0].originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", field[0].originFileObj);
            formData.append("application", "MAGP");
            const res: any = await post("management/upload-file", formData);

            if (res) {
              data[key] = res.response.data;
            }
          } else {
            data[key] = data[key][0].url;
          }
        }
      } catch (error) {}
    }

    let descKeys: any = [
      "field_contract_admin_desc_en",
      "field_contract_admin_desc_ms",
      "field_contract_admin_desc_zh",
    ];
    for (const key of descKeys) {
      try {
        data[key] = {
          value: data[key] || "",
          format: "full_html",
        };
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "Manual",
      subModule: `${query?.get("activeTab")}_${query?.get("subActiveTab")}_${query?.get("thirdChildActiveTab")}`,
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        // id: contractAdministrationDataById?.payload?.id || contractAdministrationData?.[0]?.id || "",
        field_contract_list_parent_id:
          contractAdministrationDataById?.payload?.field_contract_list_parent_id ||
          contractAdministrationData?.[0]?.field_contract_list_parent_id ||
          "",
        field_contract_admin_toggle_refe:
          contractAdministrationDataById?.payload?.field_contract_admin_toggle_refe ||
          contractAdministrationData?.[0]?.field_contract_admin_toggle_refe ||
          "",
        ...data,
        published: true,
        // field_contract_detail_created_at: "2024-07-16T07:44:25",
        // field_contract_detail_updated_at: "2024-07-16T07:44:30",
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  const superSubChildItems = tabsData.map((tab: any) => {
    return {
      label: tab.label,
      key: tab.key,
      children: (
        <Tabs
          activeKey={query?.get("thirdChildActiveTab") || ""}
          items={subTabsData.map((subTab: any) => {
            const processFlowChartTab: any[] = [
              "contractCloseoutProcessFlowChart",
              "contractTerminationProcessFlowChart",
              "contractRenewalProcessFlowChart",
              "contractManagementImplementationProcessFlowChart",
              "contractAdministrationProcessFlowChart",
            ];
            const isProcessFlowChartTab = processFlowChartTab.includes(subTab.key);

            return {
              label: subTab.label,
              key: subTab.key,
              children: isProcessFlowChartTab ? (
                <>
                  <DynamicForm
                    isLoading={isLoadingContractAdministration || isLoadingContractAdministrationById}
                    config={contractAdministrationFormConfig}
                    onSubmit={(data, buttonValue, reviewNotes) =>
                      onSubmit(
                        data,
                        `${magpHost}/api/contract-administration-details/${contractAdministrationData?.[0]?.id}`,
                        "UPDATE",
                        "PATCH",
                        buttonValue == "save" ? "DRAFT" : "PENDING",
                        reviewNotes
                      )
                    }
                  />
                  <ContractAdministrationProcessFlowChart
                    listId={listId}
                    toggleId={toggleId}
                  />
                </>
              ) : (
                <DynamicForm
                  isLoading={isLoadingContractAdministration || isLoadingContractAdministrationById}
                  config={contractAdministrationFormConfig}
                  onSubmit={(data, buttonValue, reviewNotes) =>
                    onSubmit(
                      data,
                      `${magpHost}/api/contract-administration-details/${contractAdministrationData?.[0]?.id}`,
                      "UPDATE",
                      "PATCH",
                      buttonValue == "save" ? "DRAFT" : "PENDING",
                      reviewNotes
                    )
                  }
                />
              ),
            };
          })}
          onChange={(activeKey: any) => handleSubTabChange(tab.listId, activeKey)}
        />
      ),
    };
  });

  if (isLoadingContractAdministration || isLoadingContractAdministrationById) {
    return <Loader />;
  }

  return (
    <Tabs
      activeKey={query?.get("subActiveTab") || ""}
      items={superSubChildItems}
      onChange={handleTabChange}
    />
  );
};
